import { Box, Container, Grid, useMediaQuery, useTheme } from "@mui/material";
import { Skeleton } from '@mui/material';

export const ListPageSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const iconpx = 12;
  const Icon = () => <Skeleton variant="text" width={iconpx} style={{ borderRadius: 4 }} />;

  return (
    <Container maxWidth="md" style={{ paddingTop: 16, paddingBottom: 16 }}>
      <Box display={"flex"} flexDirection={isMobile ? "column" : "row"}>
        <Box pl={2} width={280}>
          {/* list pic */}
          <Skeleton variant="rectangular" width={150} height={150} style={{ borderRadius: 4 }} />
          {/* name */}
          <Skeleton variant="text" width={80} />
          {/* total items & 2 icon buttons */}
          <Box display={"flex"} className="spacing">
            <Skeleton variant="text" width={50} />
            <Icon />
            <Icon />
          </Box>
        </Box>

        <Box ml={isMobile ? 0 : 14.2} py={2}>
          <Grid container spacing={3} justifyContent={isMobile ? "center" : "flex-start"}>
            {Array.from({ length: 4 }).map((_, i) => (
              <Grid key={`IF_SKE_${i}`} item>
                <Skeleton variant="rectangular" width={366} height={197} style={{ borderRadius: 4 }} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default ListPageSkeleton;
